<!-- src/components/map/MapContainer.vue -->
<template>
  <div class="map-wrap">
    <!-- controls -->
    <!--
    <div id="layer-control" class="layer-control">
      <div class="fields-toggle">
        <label>
          <input type="checkbox" v-model="fieldsVisible" />
          <span>Месторождения</span>
        </label>
      </div>
    </div>
    -->
    <div id="map" class="map" ref="mapContainer"></div>
  </div>
</template>

<script>
import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'
import { shallowRef, ref, markRaw, onMounted, onUnmounted, watch } from 'vue'

export default {
  name: 'MapComponent',
  props: {
    idlist: { type: Array, default: () => [], required: true }
  },
  emits: ['mapClick', 'point-click'],
  setup(props, ctx) {
    const mapContainer = shallowRef(null)
    const map = shallowRef(null)

    // чекбокс "Месторождения"
    // const fieldsVisible = ref(false)
    const geologyVisible = ref(true) // пока не используется, оставил

    // --- Настройки MapTiler: используем переданный стиль и ключ ---
    // Вставил ваш ключ/URL как значение по умолчанию
    const MAPTILER_STYLE = `https://api.maptiler.com/maps/01992869-c436-724a-9d4b-232ab8209966/style.json?key=mKbPIMJzLWhhlFDqVTeI`

    const rawMartin = (process.env.VUE_APP_MARTIN_URL || 'http://localhost:3000/').trim().replace(/\/$/, '')
    let MARTIN_BASE = rawMartin
    try {
      if (!/^https?:\/\//i.test(rawMartin)) {
        const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : ''
        MARTIN_BASE = `${origin || 'http://localhost:3000'}${rawMartin.startsWith('/') ? rawMartin : '/' + rawMartin}`
      }
      new URL(MARTIN_BASE)
    } catch (err) {
      console.warn('[MapComponent] invalid VUE_APP_MARTIN_URL, fallback to http://localhost:3000', err)
      MARTIN_BASE = 'http://localhost:3000'
    }
    const SAMPLES_TILES = [ `${MARTIN_BASE}/public.geodata/{z}/{x}/{y}.pbf` ]
    const SAMPLES_SOURCE_LAYER = 'public.geodata'

    // popup vars
    let hoverPopup = null
    let persistentPopup = null
    let selectedIdsList = []

    // Efield vars
    // let efieldLoaded = false
    // let efieldAdded = false
    // let efieldHighlightedId = null
    // const EFIELD_SOURCE = 'efield'
    // const EFIELD_FILL_LAYER = 'efield-fill'
    // const EFIELD_LINE_LAYER = 'efield-line'
    // const EFIELD_ID_PROP = 'id_map'

    function ensureMap() { if (!map.value) { console.warn('[MapComponent] map not initialised yet'); return false } return true }

    function normalizeFeatureProps(props) {
      if (!props) return {}
      const get = (...keys) => { for (const k of keys) if (props[k] !== undefined && props[k] !== null) return props[k]; return undefined }
      return {
        id: get('id', 'ID', 'pk'),
        internal_id: get('internal_id', 'internalId', 'fadr', 'fid'),
        renamed_id: get('renamed_id', 'renamedId', 'renamed', 'renamedID'),
        short_description: get('short_description', 'shortDescription', 'descr', 'description'),
        research_scale: get('research_scale', 'researchScale'),
        basin: get('basin'),
        tier: get('tier'),
        preview_images: get('preview_images') || get('images') || []
      }
    }

    // В этом варианте мы не переключаем подложки — карта создаётся сразу с вашим стилем MapTiler
    function addSamplesLayer() {
      if (!ensureMap()) return
      const src = 'samples', layerId = 'samples-layer'
      try { if (map.value.getLayer(layerId)) map.value.removeLayer(layerId) } catch(e){}
      try { if (map.value.getSource(src)) map.value.removeSource(src) } catch(e){}

      map.value.addSource(src, { type: 'vector', tiles: SAMPLES_TILES, promoteId: 'internal_id' })

      map.value.addLayer({
        id: layerId,
        type: 'circle',
        source: src,
        'source-layer': SAMPLES_SOURCE_LAYER,
        paint: {
          'circle-stroke-width': 1,
          'circle-stroke-color': '#FFFFFF',
          'circle-color': [
            'case',
            ['boolean', ['feature-state', 'beenClicked'], false],
            '#fec44f',
            '#2F2F2F'
          ],
          'circle-opacity': 0.95,
          'circle-radius': 8
        }
      })

      try { map.value.setLayoutProperty(layerId, 'visibility', 'visible') } catch(e) {}
    }

    // async function addEfieldSourceAndLayers() {
    //   if (!ensureMap()) return
    //   if (efieldAdded) {
    //     try { map.value.setLayoutProperty(EFIELD_FILL_LAYER, 'visibility', 'visible') } catch(e){}
    //     try { map.value.setLayoutProperty(EFIELD_LINE_LAYER, 'visibility', 'visible') } catch(e){}
    //     return
    //   }

    //   let geojson = null
    //   try {
    //     const res = await fetch('/Efield_region.json')
    //     if (!res.ok) throw new Error(`fetch failed ${res.status}`)
    //     geojson = await res.json()
    //     efieldLoaded = true
    //   } catch (err) {
    //     console.warn('[MapComponent] failed to load Efield_region.json', err)
    //     return
    //   }

    //   try {
    //     if (map.value.getLayer(EFIELD_FILL_LAYER)) { try { map.value.removeLayer(EFIELD_FILL_LAYER) } catch(e){} }
    //     if (map.value.getLayer(EFIELD_LINE_LAYER)) { try { map.value.removeLayer(EFIELD_LINE_LAYER) } catch(e){} }
    //     if (map.value.getSource(EFIELD_SOURCE)) { try { map.value.removeSource(EFIELD_SOURCE) } catch(e){} }

    //     map.value.addSource(EFIELD_SOURCE, { type: 'geojson', data: geojson })

    //     // compute insertion point: try to insert before samples-layer so polygons are below points
    //     let beforeId = undefined
    //     try {
    //       if (map.value.getLayer('samples-layer')) beforeId = 'samples-layer'
    //       else {
    //         const styleLayers = map.value.getStyle && map.value.getStyle().layers
    //         if (styleLayers && styleLayers.length) beforeId = styleLayers[0].id
    //       }
    //     } catch(e){}

    //     const fillLayerObj = {
    //       id: EFIELD_FILL_LAYER,
    //       type: 'fill',
    //       source: EFIELD_SOURCE,
    //       paint: {
    //         'fill-color': 'rgba(200,100,20,0.15)',
    //         'fill-outline-color': 'rgba(200,100,20,0.5)'
    //       }
    //     }

    //     const lineLayerObj = {
    //       id: EFIELD_LINE_LAYER,
    //       type: 'line',
    //       source: EFIELD_SOURCE,
    //       paint: {
    //         'line-color': 'rgba(150,80,20,0.75)',
    //         'line-width': 1.5
    //       }
    //     }

    //     if (beforeId) {
    //       map.value.addLayer(fillLayerObj, beforeId)
    //       map.value.addLayer(lineLayerObj, beforeId)
    //     } else {
    //       map.value.addLayer(fillLayerObj)
    //       map.value.addLayer(lineLayerObj)
    //     }

    //     efieldAdded = true
    //   } catch (err) {
    //     console.error('[MapComponent] addEfieldSourceAndLayers error', err)
    //     return
    //   }

    //   // interactions
    //   map.value.on('mousemove', EFIELD_FILL_LAYER, (e) => {
    //     if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
    //     map.value.getCanvas().style.cursor = 'pointer'
    //     const feat = (e.features && e.features[0]) ? e.features[0] : null
    //     if (!feat) return
    //     const props = feat.properties || {}
    //     const hint = (props.WP_NAME || props.Name || props.NGP || 'Месторождение')
    //     hoverPopup = new maplibregl.Popup({ closeButton:false, closeOnClick:false, offset:6 })
    //       .setLngLat(e.lngLat)
    //       .setHTML(`<div style="background: rgba(255,255,255,0.95); padding:6px 10px; border-radius:6px; color:#222; font-weight:700">${hint}</div>`)
    //       .addTo(map.value)
    //   })

    //   map.value.on('mouseleave', EFIELD_FILL_LAYER, () => {
    //     map.value.getCanvas().style.cursor = ''
    //     if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
    //   })

    //   map.value.on('click', EFIELD_FILL_LAYER, (e) => {
    //     try {
    //       if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }

    //       const feat = (e.features && e.features[0]) ? e.features[0] : null
    //       if (!feat) return
    //       const props = feat.properties || {}
    //       const clickedId = (props.id_map ?? props.id_map1 ?? props.id)
    //       efieldHighlightedId = clickedId !== undefined && clickedId !== null ? String(clickedId) : null

    //       try {
    //         const expr = ['case', ['==', ['to-string', ['get', EFIELD_ID_PROP]], String(efieldHighlightedId)], '#f1c40f', 'rgba(200,100,20,0.15)']
    //         map.value.setPaintProperty(EFIELD_FILL_LAYER, 'fill-color', expr)
    //       } catch (err) { console.warn('[MapComponent] setPaintProperty highlight failed', err) }

    //       const hint = (props.WP_NAME || props.Name || 'Месторождение')
    //       if (persistentPopup) { try { persistentPopup.remove() } catch(e){}; persistentPopup = null }
    //       persistentPopup = new maplibregl.Popup({ closeButton:true, closeOnClick:false, offset:6 })
    //         .setLngLat(e.lngLat)
    //         .setHTML(`<div style="background: rgba(255,255,255,0.98); padding:8px 12px; border-radius:8px; color:#222; font-weight:700">${hint}</div>`)
    //         .addTo(map.value)

    //     } catch (err) { console.error(err) }
    //   })

    //   // clear highlight on map click if click outside efield polygons
    //   map.value.on('click', (e) => {
    //     const feats = map.value.queryRenderedFeatures(e.point, { layers: [EFIELD_FILL_LAYER] })
    //     if (!feats || feats.length === 0) {
    //       efieldHighlightedId = null
    //       try { map.value.setPaintProperty(EFIELD_FILL_LAYER, 'fill-color', 'rgba(200,100,20,0.15)') } catch(e){}
    //       if (persistentPopup) { try { persistentPopup.remove() } catch(e){}; persistentPopup = null }
    //     }
    //   })
    // }

    // filter samples by idlist
    function updateSamplesFilter() {
      if (!ensureMap()) return
      const layerId = 'samples-layer'

      let ids = []
      if (Array.isArray(props.idlist) && props.idlist.length) {
        const first = props.idlist[0]
        if (first && typeof first === 'object' && Array.isArray(first.items)) {
          for (const p of props.idlist) {
            if (!p || !Array.isArray(p.items)) continue
            for (const it of p.items) {
              const val = it && (it.internal_id ?? it.renamed_id ?? it.id ?? it.pk ?? (it.__raw && (it.__raw.internal_id ?? it.__raw.id)))
              if (val !== undefined && val !== null) ids.push(val)
            }
          }
        } else {
          ids = props.idlist.slice()
        }
      }

      const sanitized = Array.from(new Set(
        ids
          .filter(x => x !== undefined && x !== null)
          .map(x => {
            if (typeof x === 'object') {
              if (x.id !== undefined && x.id !== null) return String(x.id)
              try { return JSON.stringify(x) } catch(e){ return String(x) }
            }
            return String(x)
          })
      ))


      if (!map.value.getLayer(layerId)) {
        try { addSamplesLayer() } catch(e) { console.warn('[MapComponent] addSamplesLayer failed', e) }
        return
      }

      try {
        if (!sanitized || sanitized.length === 0) {
          try { map.value.setLayoutProperty(layerId, 'visibility', 'none') } catch (err) {}
          try { map.value.setFilter(layerId, null) } catch(e) {}
          return
        }

        const expr = [
          'match',
          ['to-string', ['coalesce', ['get', 'internal_id'], ['get', 'renamed_id'], ['get', 'fadr'], ['get', 'id']]],
          sanitized,
          true,
          false
        ]

        try { map.value.setLayoutProperty(layerId, 'visibility', 'visible') } catch(e){}
        map.value.setFilter(layerId, expr)
      } catch (e) {
        console.error('[MapComponent] updateSamplesFilter - setFilter error:', e, 'sanitized:', sanitized)
        try {
          const simple = ['match', ['to-string', ['get', 'internal_id']], sanitized, true, false]
          map.value.setLayoutProperty(layerId, 'visibility', 'visible')
          map.value.setFilter(layerId, simple)
        } catch (err2) {
          console.error('[MapComponent] updateSamplesFilter - fallback failed', err2)
          try { map.value.setLayoutProperty(layerId, 'visibility', 'none') } catch(e) {}
        }
      }
    }

    function clearSelections() {
      if (!ensureMap()) return
      const old = [...selectedIdsList]
      old.forEach(id => { try { map.value.setFeatureState({ source: 'samples', sourceLayer: SAMPLES_SOURCE_LAYER, id }, { beenClicked: false }) } catch(e){} })
      selectedIdsList.length = 0
      if (persistentPopup) { try { persistentPopup.remove() } catch(e){} }
      persistentPopup = null
      ctx.emit('mapClick', { fadr: [] })
    }

    function buildMap() {
      // создаём карту сразу со стилем MapTiler
      map.value = markRaw(new maplibregl.Map({
        container: mapContainer.value,
        style: MAPTILER_STYLE,
        center: [80,40],
        zoom: 2,
        maxZoom: 18
      }))

      map.value.on('load', () => {
        // После загрузки стиля добавляем слой с образцами и навешиваем ивенты
        try { addSamplesLayer() } catch(e){ console.warn(e) }

        map.value.on('mousemove', 'samples-layer', (e) => {
          if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
          map.value.getCanvas().style.cursor = 'pointer'
          const count = (e.features && e.features.length) ? e.features.length : 1
          hoverPopup = new maplibregl.Popup({ closeButton:false, closeOnClick:false, offset:6 })
            .setLngLat(e.lngLat)
            .setHTML(`<div style="background: rgba(255,255,255,0.98); padding:6px 10px; border-radius:8px; color:#222; font-weight:700">Записей в точке: ${count}</div>`)
            .addTo(map.value)
        })

        map.value.on('mouseleave', 'samples-layer', () => {
          map.value.getCanvas().style.cursor = ''
          if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
        })

        map.value.on('click', 'samples-layer', (e) => {
          try {
            if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
            const feats = (e.features && e.features.length) ? e.features : []
            if (!feats.length) return
            const items = feats.map(f => {
              const p = normalizeFeatureProps(f.properties || {})
              return { ...p, __raw: f.properties, __fid: f.id }
            })

            if (selectedIdsList && selectedIdsList.length) {
              for (const id of selectedIdsList) {
                try { map.value.setFeatureState({ source: 'samples', sourceLayer: SAMPLES_SOURCE_LAYER, id }, { beenClicked: false }) } catch(e){}
              }
            }

            selectedIdsList = []
            for (const f of feats) {
              const fid = f.id ?? (f.properties && (f.properties.internal_id ?? f.properties.fadr ?? f.properties.id))
              const sid = fid !== undefined && fid !== null ? String(fid) : null
              if (sid) {
                try { map.value.setFeatureState({ source: 'samples', sourceLayer: SAMPLES_SOURCE_LAYER, id: sid }, { beenClicked: true }) } catch(e){}
                selectedIdsList.push(sid)
              }
            }

            const count = items.length
            if (persistentPopup) { try { persistentPopup.remove() } catch(e){}; persistentPopup = null }
            persistentPopup = new maplibregl.Popup({ closeButton:false, closeOnClick:false, offset:6 })
              .setLngLat(e.lngLat)
              .setHTML(`<div style="background: rgba(255,255,255,0.98); padding:6px 12px; border-radius:8px; color:#222; font-weight:700">Записей в точке: ${count}</div>`)
              .addTo(map.value)

            ctx.emit('point-click', { lon: e.lngLat.lng, lat: e.lngLat.lat, count, items })
            ctx.emit('mapClick', { fadr: items.map(i => i.internal_id || i.id || i.__raw?.internal_id) })
          } catch (err) { console.error(err) }
        })

        map.value.on('click', (e) => {
          const features = map.value.queryRenderedFeatures(e.point)
          if (!features || features.length === 0) {
            clearSelections()
            ctx.emit('point-click', null)
          }
        })
      })
    }

    // WATCHERS
    watch(() => props.idlist, () => { try { updateSamplesFilter() } catch(e) { console.warn(e) } }, { deep: true, immediate: true })

    // show/hide efield layer when checkbox toggled
    // watch(fieldsVisible, (val) => {
    //   try {
    //     if (!map.value) return
    //     if (!efieldAdded && val) {
    //       addEfieldSourceAndLayers().catch(()=>{})
    //       return
    //     }
    //     const vis = val ? 'visible' : 'none'
    //     try { map.value.setLayoutProperty(EFIELD_FILL_LAYER, 'visibility', vis) } catch(e){}
    //     try { map.value.setLayoutProperty(EFIELD_LINE_LAYER, 'visibility', vis) } catch(e){}

    //     // when hiding, clear highlight and popups
    //     if (!val) {
    //       efieldHighlightedId = null
    //       try { map.value.setPaintProperty(EFIELD_FILL_LAYER, 'fill-color', 'rgba(200,100,20,0.15)') } catch(e){}
    //       if (hoverPopup) { try { hoverPopup.remove() } catch(e){}; hoverPopup = null }
    //       if (persistentPopup) { try { persistentPopup.remove() } catch(e){}; persistentPopup = null }
    //     }
    //   } catch (err) {
    //     console.warn('[MapComponent] watch fieldsVisible error', err)
    //   }
    // }, { immediate: false })

    onMounted(() => buildMap())
    onUnmounted(() => { try { if (map.value) map.value.remove() } catch(e){} })

    return {
      mapContainer,
      // fieldsVisible,
      geologyVisible
    }
  }
}
</script>

<style scoped>
.map-wrap {
  position: relative;
  height: 100vh;
  width: 100%;
}

.map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.layer-control {
  position: absolute;
  top: calc(var(--header-height, 64px) + 12px);
  right: 1rem;
  z-index: 1000;
  display:flex;
  flex-direction:column;
  gap:10px;
  background: rgba(0,0,0,0.35);
  padding:8px;
  border-radius:8px;
}

.layer-control input[type="radio"], .layer-control input[type="checkbox"] {
  transform: scale(1.05);
  gap: 10px;
}

.layer-control span {
  color: white;
  text-shadow: 0 0 3px black;
}
</style>
